export default "__VITE_ASSET__e74926c4__"